import { formatMoney } from "@/components/CurrencySelector";
import { cn } from "@/lib/utils";

/**
 * Right-aligned amount for an expense row. A converted expense (entered in a
 * non-CAD currency) shows the base amount with what was entered on a small
 * line underneath — instead of one long "US$1,234.00 → $1,700.00" string
 * that crushes the description next to it on a phone.
 */
export function ExpenseAmount({
  amount,
  currency,
  originalAmount,
  viewerCurrency,
  baseCurrency,
  className,
}: {
  amount: number;
  currency?: string | null;
  originalAmount?: number | null;
  viewerCurrency?: string | null;
  /** What a converted amount was stored in (null = CAD, every older row). */
  baseCurrency?: string | null;
  className?: string;
}) {
  const converted = !!currency && originalAmount != null && currency !== (baseCurrency || "CAD");
  return (
    <span className={cn("shrink-0 text-right", className)}>
      <span className="block whitespace-nowrap">
        {formatMoney(amount, converted ? (baseCurrency || "CAD") : viewerCurrency)}
      </span>
      {converted && (
        <span className="block whitespace-nowrap font-mono text-[11px] font-normal text-muted-foreground">
          {/* A CAD original next to a non-CAD amount needs the explicit CA$. */}
          {currency === "CAD" ? formatMoney(originalAmount!, currency).replace(/^\$/, "CA$") : formatMoney(originalAmount!, currency)}
        </span>
      )}
    </span>
  );
}
